// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"ac8c004d","146":"8fa80d66","556":"61accd4d","790":"6f57c0a1","993":"88d902d5"}[chunkId] + ".chunk.js";
};